"use strict";

const LoadClinicalPort = {
  add: function (app) {
    if (app.ports.dispatchLoadClinicalPort) {
      app.ports.dispatchLoadClinicalPort.subscribe(() => {
        window.dispatchEvent(new CustomEvent("core-ready"));
      });
    }
  },
};

module.exports = LoadClinicalPort;
